const getters = {
  token: (state) => state.user.token,
  username: (state) => state.user.username,
  roles: (state) => state.user.roles,
  permission: (state) => state.user.permission,
  designatedSuperAdmin: (state) => state.user.designatedSuperAdmin,
};
export default getters;
